import { z } from 'zod'

export const contactFormPayloadSchema = z.object({
  company: z.string().trim().max(120, 'Keep the company or project under 120 characters.'),
  email: z.string().trim().email('Use a real email address.').max(160, 'Keep the email under 160 characters.'),
  message: z
    .string()
    .trim()
    .min(30, 'Give me a little more to work with.')
    .max(4_000, 'Keep the message under 4000 characters.'),
  name: z.string().trim().min(2, 'Tell me your name.').max(80, 'Keep the name under 80 characters.'),
  reason: z.string().trim().min(1, 'Pick a reason.').max(120, 'Keep the reason under 120 characters.'),
  startedAt: z.number().int().positive(),
  website: z.string().max(0).default(''),
})

export type ContactFormPayload = z.infer<typeof contactFormPayloadSchema>
export type ContactFormFieldName = 'company' | 'email' | 'message' | 'name' | 'reason'
export type ContactFormValues = Omit<ContactFormPayload, 'startedAt'>

export function getDefaultContactFormValues(): ContactFormValues {
  return {
    company: '',
    email: '',
    message: '',
    name: '',
    reason: '',
    website: '',
  }
}
